import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { Branch } from './branch.model';
import { Division } from './division.model';
import { Product } from './product.model';
import { Role } from './role.model';

/**
 * Extended User model for FLOW application
 */
export class User {
  id!: number;
  first_name!: string;
  last_name!: string;
  name?: string;
  email!: string;
  lang!: string;
  last_connection!: string;
  igg!: string;
  role_id!: number;

  // Application-specific properties
  division_id?: number;
  branch_ids?: number[];
  product_ids?: number[];

  division?: Division;
  branches?: Branch[];
  products?: Product[];

  created_at?: string;
  updated_at?: string;
  deleted_at?: string;

  role!: Role;

  constructor(data: object = {}) {
    Object.assign(this, data);

    // Initialize related entities
    if (this.role && !(this.role instanceof Role)) {
      this.role = new Role(this.role);
    }
    if (this.division && !(this.division instanceof Division)) {
      this.division = new Division(this.division);
    }
    if (this.branches) {
      this.branches = this.branches.map(branch =>
        branch instanceof Branch ? branch : new Branch(branch)
      );
    }
    if (this.products) {
      this.products = this.products.map(product =>
        product instanceof Product ? product : new Product(product)
      );
    }
  }

  isAdmin() {
    return this.isRole(MpsRoleHelper.ADMIN);
  }

  isRole(roleCode: string) {
    return MpsRoleHelper.getRoleIdFromCode(roleCode) === this.role_id;
  }
}
